<template>
  <section class="section-schedule">
    <div class="section-title">
      <span class="dot-left">
        <i></i>
        <i></i>
        <i></i>
      </span>
      {{ $t("content.schedule.title") }}
      <span class="dot-right">
        <i></i>
        <i></i>
        <i></i>
      </span>
    </div>

    <div class="content-outer">
      <div class="schedule-wrap">
        <div class="schedule-card" @click="$router.push('/schedule')">
          <img :src="require('@/assets/images/schedule-main.png')" alt="大会主会场" />
          <div class="card-text">{{ $t("content.schedule.main") }}</div>
        </div>
        <div class="schedule-card" @click="$router.push('/schedule/sub')">
          <img :src="require('@/assets/images/schedule-sub.png')" alt="大会分会场" />
          <div class="card-text">{{ $t("content.schedule.sub") }}</div>
        </div>
      </div>

      <!-- ✅ 会议手册下载入口 -->
      <div class="handbook-wrap">
        <a
          class="handbook-btn"
          href="/2026ICEDM会议手册.pdf"
          target="_blank"
          rel="noopener"
          download
        >
          <svg class="handbook-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6zm7 1.5L18.5 9H13V3.5zM8 13h8v1.6H8V13zm0 3.2h8v1.6H8v-1.6z"/>
          </svg>
          <span>{{ $t("content.schedule.handbook") }}</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "SectionSchedule"
}
</script>

<style scoped>
.section-schedule {
  padding: 40px;
  width: 100%;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  font-size: 24px;
  font-weight: 500;
  color: #0f3494;
  margin: 0 0 40px;
}
.dot-left, .dot-right {
  display: flex;
  align-items: center;
  gap: 2px;
}
.dot-left i, .dot-right i {
  background-color: #0f3494;
  border-radius: 2px;
}
.dot-left i:nth-child(1) { width: 5px; height: 5px; }
.dot-left i:nth-child(2) { width: 8px; height: 8px; }
.dot-left i:nth-child(3) { width: 12px; height: 12px; }
.dot-right i:nth-child(1) { width: 12px; height: 12px; }
.dot-right i:nth-child(2) { width: 8px; height: 8px; }
.dot-right i:nth-child(3) { width: 5px; height: 5px; }

.content-outer {
  max-width: 1300px;
  margin: 0 auto;
}
.schedule-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.schedule-card {
  width: 100%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
}

/* 图片铺满容器，无留白裁切 */
.schedule-card img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

/* 文字安全边距，移动端不会贴边被截断 */
.card-text {
  position: absolute;
  left: 6%;
  top: 50%;
  transform: translateY(-50%);
  font-size: 32px;
  color: #0f3494;
  font-weight: 500;
}

/* ===== ✅ 会议手册下载按钮（方案 A：浅蓝底胶囊） ===== */
.handbook-wrap {
  margin-top: 26px;
  display: flex;
  justify-content: center;
}

.handbook-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 32px;
  font-size: 18px;                              /* 比标题 24px 略小 */
  font-weight: 500;
  color: #0f3494;
  letter-spacing: 0.5px;
  text-decoration: none;
  background: rgba(15, 52, 148, 0.06);          /* 浅蓝底 */
  border: 1px solid rgba(15, 52, 148, 0.35);
  border-radius: 999px;                         /* 胶囊形 */
  box-shadow: 0 4px 12px rgba(15, 52, 148, 0.08);
  transition: all 0.2s ease;
  cursor: pointer;
}

.handbook-btn:hover {
  background: rgba(15, 52, 148, 0.15);
  border-color: #0f3494;
  color: #0f3494;
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(15, 52, 148, 0.18);
}

.handbook-btn:active {
  transform: translateY(0);
  box-shadow: 0 4px 10px rgba(15, 52, 148, 0.12);
}

.handbook-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* 平板 */
@media screen and (max-width: 1200px) {
  .content-outer {
    max-width: 96%;
  }
  .card-text {
    font-size: 26px;
    left: 8%;
  }
  .handbook-btn {
    font-size: 16px;
    padding: 10px 26px;
  }
  .handbook-icon {
    width: 18px;
    height: 18px;
  }
}

/* 移动端 */
@media screen and (max-width: 768px) {
  .section-schedule {
    padding: 30px 16px 35px;
  }
  .section-title {
    font-size: 20px;
    gap: 10px;
    margin-bottom: 28px;
  }
  .dot-left i:nth-child(3), .dot-right i:nth-child(1) { width: 8px; height: 8px; }
  .dot-left i:nth-child(2), .dot-right i:nth-child(2) { width: 6px; height: 6px; }
  .dot-left i:nth-child(1), .dot-right i:nth-child(3) { width: 4px; height: 4px; }

  .schedule-wrap {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .card-text {
    font-size: 22px;
    left: 10%;
  }

  .handbook-wrap {
    margin-top: 26px;
  }
  .handbook-btn {
    font-size: 15px;
    padding: 10px 22px;
    gap: 8px;
  }
  .handbook-icon {
    width: 16px;
    height: 16px;
  }
}
</style>